import React, { FC, SVGProps } from 'react';

interface TrendingIconProps extends SVGProps<SVGSVGElement> {
  width?: number;
  height?: number;
}

const TrendingIcon: FC<TrendingIconProps> = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="lucide lucide-trending-up"
    style={{ color: 'white' }}
    {...props}
  >
    <polyline points="22 7 13.5 15.5 8.5 10.5 2 17" />
    <polyline points="16 7 22 7 22 13" />
  </svg>
);

export { TrendingIcon };
